import { TriangleAlert, ArrowRight } from "lucide-react";

export default function HitlBanner({ count, onClick }) {
  if (!count) return null;

  return (
    <button
      type="button"
      data-testid="hitl-banner"
      onClick={onClick}
      className="group flex w-full items-center gap-4 overflow-hidden rounded-3xl border border-[#FFE0B2] bg-[#FFF7EE] p-0 text-left transition-all hover:-translate-y-0.5 hover:shadow-[0_12px_28px_-16px_rgba(249,115,22,0.35)]"
    >
      <div className="h-full w-1 self-stretch bg-orange-500" />
      <div className="flex flex-1 items-center gap-4 py-4 pr-5">
        <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl bg-orange-500/15 text-orange-700">
          <TriangleAlert className="h-5 w-5" strokeWidth={2.4} />
        </div>
        <div className="flex-1">
          <div
            data-testid="hitl-banner-eyebrow"
            className="text-[10px] font-bold uppercase tracking-[0.18em] text-orange-700"
          >
            Human action required · {count}
          </div>
          <div className="mt-0.5 text-[15px] font-bold text-zinc-900">
            You have {count} task{count === 1 ? "" : "s"} blocking the boardroom — review now
          </div>
        </div>
        <span className="inline-flex items-center gap-1 rounded-full bg-white/70 px-3 py-1.5 text-[12px] font-semibold text-orange-700 transition-colors group-hover:bg-white">
          View all
          <ArrowRight
            className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5"
            strokeWidth={2.4}
          />
        </span>
      </div>
    </button>
  );
}
